import React from 'react';
import { bool, number } from 'prop-types';
import { Box } from '@mui/material';
import { I18n } from 'utils/i18n';
import moment from 'moment';

const Information = ({
  confirmedAt = null,
  digitalSignature = false,
  isMe = true,
  viewingReceipt = false,
}) => {
  let description = isMe
    ? I18n.t(
        'AcknowledgementReadModal.Please, read what follows and confirm reception by clicking the button below',
      )
    : '';
  if (confirmedAt && digitalSignature) {
    description = `${I18n.t('AcknowledgementReadModal.Digital signature made on')} ${moment
      .unix(confirmedAt)
      .format('LL')}`;
  } else if (confirmedAt) {
    description = `${I18n.t('AcknowledgementReadModal.Signed on')} ${moment
      .unix(confirmedAt)
      .format('LL')}`;
  }
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        mb: '15px',
      }}
    >
      <Box
        component="span"
        sx={{
          color: 'primary.dark',
          fontSize: '12px',
          fontWeight: 500,
          textTransform: 'uppercase',
          mb: '8px',
        }}
      >
        {viewingReceipt
          ? I18n.t('AcknowledgementReadModal.RECEIPT CERTIFICATE')
          : digitalSignature
            ? I18n.t('AcknowledgementReadModal.DIGITAL SIGNATURE')
            : I18n.t('AcknowledgementReadModal.MANDATORY READ')}
      </Box>
      <Box
        component="span"
        sx={{
          fontSize: '14px',
          ...(confirmedAt
            ? { color: 'primary.dark' }
            : { color: '#8b98ab', textAlign: 'center', width: '70%', display: 'block' }),
        }}
      >
        {description}
      </Box>
    </Box>
  );
};

Information.propTypes = {
  confirmedAt: number,
  digitalSignature: bool,
  isMe: bool,
  viewingReceipt: bool,
};

export default Information;
